/** Per-sport branding for Match Hub team registration pages. */
export const SPORT_SIGNUP_THEME = Object.freeze({
  football: {
    icon: "fa-solid fa-futbol",
    kicker: "Football · Match Hub",
    title: "Register your football team",
    lead:
      "Set up an 11-a-side squad with a home ground, roster, and match preferences. Build your profile so rivals can challenge you and schedule fixtures across Kenya.",
    stepIcons: [
      "fa-solid fa-futbol",
      "fa-solid fa-location-dot",
      "fa-solid fa-clipboard-check",
    ],
  },
  basketball: {
    icon: "fa-solid fa-basketball",
    kicker: "Basketball · Match Hub",
    title: "Register your basketball team",
    lead:
      "Set up a squad for 5v5 full court or 3v3 half court. We use standard roster sizes (8–15 players) so fixtures and substitutions stay fair.",
    stepIcons: [
      "fa-solid fa-basketball",
      "fa-solid fa-location-dot",
      "fa-solid fa-clipboard-check",
    ],
  },
  rugby: {
    icon: "fa-solid fa-football",
    kicker: "Rugby · Match Hub",
    title: "Register your rugby team",
    lead:
      "Set up a club for 15-a-side, 7s, or 10s. Target squads of 15–30 players so fixtures, replacements, and training blocks stay organized.",
    stepIcons: [
      "fa-solid fa-football",
      "fa-solid fa-location-dot",
      "fa-solid fa-clipboard-check",
    ],
  },
  volleyball: {
    icon: "fa-solid fa-volleyball",
    kicker: "Volleyball · Match Hub",
    title: "Register your volleyball team",
    lead:
      "Set up a crew for 6v6 indoor or beach volleyball. Standard roster sizes (6–14) keep rotations and substitutions fair across leagues.",
    stepIcons: [
      "fa-solid fa-volleyball",
      "fa-solid fa-location-dot",
      "fa-solid fa-clipboard-check",
    ],
  },
});
